import { IUserPreference } from '../user/model';
import { createReducer, on } from '@ngrx/store';
import { userPreferencesActions } from './user-preferences.actions';

export interface IUserPreferencesState {
  preferences: IUserPreference | null
}

export const initialState: IUserPreferencesState = {
  preferences: null,
};

export const userPreferenceReducer = createReducer(
  initialState,
  on(userPreferencesActions.setPreferencesToStore, (state, action) => ({
    ...state,
    preferences: action.preferences,
  })),
);
